
import Vue from 'vue/dist/vue.esm'

Vue.component(
  "rfc-alerts-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/RfcAlerts")
)
